
import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const holidaysApi = api
  .enhanceEndpoints({ addTagTypes: ["holidays"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      holidays: builder.query({
        query: ({ branchId }: any) => ({
          url: `branchs/${branchId}/holidays`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) =>
          snakeToCamel(
            response.data.map((holiday: any) => ({
              ...holiday,
              start_time: holiday.time_start,
              end_time: holiday.time_end,
            }))
          ),
        providesTags: ["holidays"],
      }),
      createHoliday: builder.mutation({
        query: ({
          branchId,
          description,
          type,
          date,
          time_start,
          time_end,
        }: any) => ({
          url: `branchs/${branchId}/holidays`,
          method: RequestMethod.POST,
          body: camelToSnake({
            type,
            date,
            description,
            time_start,
            time_end,
          }),
        }),
        transformResponse: (response: any) => response.data,
        invalidatesTags: ["holidays"],
      }),
      updateHoliday: builder.mutation({
        query: ({
          id,
          branchId,
          description,
          type,
          date,
          time_start,
          time_end,
        }: any) => ({
          url: `branchs/${branchId}/holidays/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            type,
            date,
            description,
            time_start,
            time_end,
          }),
        }),
        transformResponse: (response: any) => response.data,
        invalidatesTags: ["holidays"],
      }),
      deleteHoliday: builder.mutation({
        query: ({ branchId, id }: any) => ({
          url: `branchs/${branchId}/holidays/${id}`,
          method: RequestMethod.DELETE,
        }),
        transformResponse: (response: any) => response.data,
        invalidatesTags: ["holidays"],
      }),
    }),
  });

export const {
  useHolidaysQuery,
  useCreateHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
} = holidaysApi;
